import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './Tooltip.scss';
import { useIsHomePageVariantHook } from '../../hooks/useIsHomePageVariantHook';

const TooltipBody = ({ children }) => {
  const isVariant = useIsHomePageVariantHook();
  return (
    <div
      aria-live="off"
      className={clsx('flex flex-column', styles.tooltipBody)}
    >
      <div className={clsx('pad-lr pad-1-t', !isVariant && 'pad-b')}>
        {children}
      </div>
    </div>
  );
};

TooltipBody.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TooltipBody;
